import React, { useState, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Swal from "sweetalert2";
import axios from "axios";
import { BaseURL, uniqueToken } from "../../api/DataApis";

function Edit(props) {
  document.title = "Users | Edit";
  const navigate = useNavigate();
  const location = useLocation();
  const UserEditData = location?.state?.UserEditData;
  console.log("UserEditData", UserEditData);

  const [Name, setName] = useState("");
  const [selectedStatusType, setSelectedStatusType] = useState("");
  const [Mobile, setMobile] = useState("");
  const [Email, setEmail] = useState("");
  const [VehicleNumber, setVehicleNumber] = useState("");
  const [smartDeviceNumber, setSmartDeviceNumber] = useState("");
  const [smartDeviceNumbers, setSmartDeviceNumbers] = useState([]);
  const [selectedParent, setselectedParent] = useState("");
  const [userType, setUserType] = useState("");
  const [LongitudePoints, setLongitudePoints] = useState("");
  const [Address, setAddress] = useState("");
  
  const [countries, setCountries] = useState([]);
  const [states, setStates] = useState([]);
  const [cities, setCities] = useState([]);
  const [selectedCountry, setSelectedCountry] = useState({ _id: '', id:'' });
  const [selectedState, setSelectedState] = useState({ _id: '', name: '' });
  const [selectedCity, setSelectedCity] = useState('');
  const [Users, setUsers] = useState({});
  const [loading, setLoading] = useState(false);
  const [Imageurl, setImageurl] = useState("");
  const [selectedFile, setSelectedFile] = useState(null);
  const [StationData, setStationData] = useState([]);
  const [selectedStation, setselectedstation] =  useState('');
  const [formInitialized, setFormInitialized] = useState(false);
  


  const fetchData = async () => {
    const apiEndpoint = `${BaseURL}/user/detail/${UserEditData?._id}`;
  
    setLoading(true); // Set loading to true before fetching
    try {
      let res = await axios.get(apiEndpoint, {
        headers: {
          'Content-type': 'application/json; charset=UTF-8',
          Authorization: `Bearer ${uniqueToken}`,
        }
      });
      if (res && res.data?.user) {
        setUsers(res?.data?.user);
      } else {
        console.error("No user data found");
      }
    } catch (error) {
      console.error("Error fetching user data:", error);
    } finally {
      setLoading(false); // Set loading to false after fetching
    }
  };
  
  useEffect(() => {
    fetchData();
  }, []);


  const handleUserTypeChange = (e) => setUserType(e.target.value);
  const handleNameChange = (e) => setName(e.target.value);
  const handleEmailChange = (e) => setEmail(e.target.value);
  const handleVehicleNumberChange = (e) => setVehicleNumber(e.target.value);
  //const handleSmartDeviceNumber = (e) => setSmartDeviceNumber(e.target.value);
  
  const handleSmartDeviceNumber = (e) => {
    
    const value = e.target.value;
    // Add on space
    if (value.endsWith(' ')) {
      const trimmed = value.trim();
      if (trimmed && !smartDeviceNumbers.includes(trimmed)) {
        setSmartDeviceNumbers([...smartDeviceNumbers, trimmed]);
      }
      setSmartDeviceNumber('');
    } else {
      setSmartDeviceNumber(value);
    }
  };

  const removeSmartDeviceNumber = (index) => {
    const updated = [...smartDeviceNumbers];
    updated.splice(index, 1);
    setSmartDeviceNumbers(updated);
  };
  
  const handleParentChange = (e) => setselectedParent(e.target.value);
  const handleAddressChange = (e) => setAddress(e.target.value);
  const handleCityChange = (e) => setSelectedCity(e.target.value);
  const handleStationID = (e) => {
    setselectedstation(e.target.value);
  }

  const FetchStationsData = async () => {
    setLoading(true);
    const url = `${BaseURL}/station`;

    try {
      const res = await axios({
        url: url,
        method: "GET",
        headers: {
          "Content-type": "application/json; charset=UTF-8",
          Authorization: `Bearer ${uniqueToken}`,
        },
      });
      if (res && res.data.data) {
        setStationData(res.data.data);
        
      }
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    FetchStationsData(); // Pass current page and search query to the fetch function
  }, []);

  const handleSelectFileChange = (event) => {
    const file = event.target.files[0]; // Get the selected file
    if (file) {
      // Create a URL for the selected file and set it to state
      const imageUrl = URL.createObjectURL(file);
      setImageurl(imageUrl);
      setSelectedFile(file);
    }
  };
  
    // setImageurl(e.target.files[0])};
  const handleStatusChange = (e) => setSelectedStatusType(e.target.value);

 
  const handleMobileChange =(e) => {
    setMobile(e.target.value);
  }

  const handleCountryChange = (e) => {
    // const selectedOptionKey = e.target.options[e.target.selectedIndex];
    // const country_id = selectedOptionKey.getAttribute('data-key');

    const countryId = e.target.value;

    const selectedOption = countries.find(country => country._id === countryId );
    //console.log("---selectedOption--", selectedOption);
    setSelectedCountry({ _id: selectedOption._id, id: selectedOption.id });
    setFormInitialized(true);
    
  };
  
  const handleStateChange = (e) => {
  const selectedOption = states.find(state => state.id === e.target.value);
  setSelectedState({ _id: selectedOption._id, id: selectedOption.id });
  setFormInitialized(true);
  };

  useEffect(() => {
    const fetchCountries = async () => {
      try {
        const response = await axios.get(`${BaseURL}/settings/countries`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        
        setCountries(response.data.data);
      } catch (error) {
        console.error("Error fetching countries:", error);
      }
    };

    fetchCountries();
  }, []);

  useEffect(() => {
    if (selectedCountry.id) {
      const fetchStates = async () => {
        try {
          const response = await axios.get(`${BaseURL}/settings/states/${selectedCountry.id}`, {
            headers: {
              Authorization: `Bearer ${uniqueToken}`,
            },
          });
          
          setStates(response.data.data.data);
          setCities([]);
        } catch (error) {
          console.error("Error fetching states:", error);
        }
      };

      fetchStates();
    }
  }, [selectedCountry.id]);
  console.log("selectedState.id", selectedState.id);

  const fetchCities = async () => {
    if (selectedState.id) {
      try {
        const response = await axios.get(`${BaseURL}/settings/cities/${selectedState.id}`, {
          headers: {
            Authorization: `Bearer ${uniqueToken}`,
          },
        });
        console.log("Cities API Response:", response.data); 
        if (response.data && response.data.data) {
          setCities(response.data.data.data);
        } else {
          console.warn("No cities data found in response:", response);
          setCities([]); // Clear the cities if response is empty
        }
      } catch (error) {
        console.error("Error fetching cities:", error);
        setCities([]); // Clear the cities in case of error
      }
    }
  };
  useEffect(() => {
    fetchCities(); // Ensure this function is called when selectedState.id changes
  }, [selectedState.id]);

  useEffect(() => {
    console.log("formInitialized", formInitialized);
    if (Users && !formInitialized ) {
      // Set the input fields with the fetched user data
      setName(Users?.name || "");
      setMobile(Users?.mobile || "");
      setEmail(Users?.email || "");
      setVehicleNumber(Users?.vehicle_number || "");
      setselectedParent(Users?.parent || "");
      setAddress(Users?.address || "");
      setUserType(Users?.userType || "");
      //setSmartDeviceNumber(Users?.smartDevice || "");
      console.log("Users?.smartDevice", Users?.smartDevice);
      const smartArray = Users?.smartDevice?.map(item => item.IMEI) || [];
      setSmartDeviceNumbers(smartArray);


      if (Users?.station_id && Array.isArray(Users.station_id) && Users.station_id.length > 0) {
      setselectedstation(Users.station_id[0]);
      } else {
        console.error("station_id is undefined, not an array, or empty");
      }
      
  
      // Only set the country, state, and city once after fetching data
      if (!selectedCountry._id && Users?.countryId) {
        const country = countries.find(c => c._id === Users?.countryId[0]);
        if (country) {
          setSelectedCountry({ _id: country._id, id: country.id });
        }
      }
  
      if (!selectedState._id && Users?.stateId) {
        const state = states.find(s => s._id === Users?.stateId[0]);
        if (state) {
          setSelectedState({ _id: state._id, id: state.id });
        }
      }
  
      if (!selectedCity && Users?.cityId) {
        const city = cities.find(c => c._id === Users?.cityId[0]);
        if (city) {
          setSelectedCity(city._id);
        }
      }

      //setFormInitialized(true); // ✅ Don't run this again
    }
  }, [Users, countries, states, cities]);
  useEffect(() => {
   
    setImageurl(Users?.imageURL || null);
      
    },
   [Users]);
  
  

  const EditUser = async (UserEditData) => {
    if (!UserEditData || !UserEditData._id) {
      console.error("User ID is missing or UserEditData is invalid");
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "User ID is missing.",
      });
      return;
    }

    let formData = new FormData();
    formData.append("name", Name);
    formData.append("address", Address);
    formData.append("mobile", Mobile);
    formData.append("email", Email);
    // formData.append("status", selectedStatusType);
    formData.append("userType", userType);
    formData.append("countryId", selectedCountry._id);
    formData.append("stateId", selectedState._id);
    formData.append("cityId", selectedCity);

    if (selectedFile) {
      formData.append("profile_image", selectedFile);
    }
    if(VehicleNumber) {
      formData.append("vehicle_number",VehicleNumber);
    }
    if(selectedStation) {
      formData.append("station_id", selectedStation);
    }

    const imeiObjects = smartDeviceNumbers.map(imei => ({ IMEI: imei }));

    imeiObjects.forEach((item, index) => {
      formData.append(`smartDevice[${index}][IMEI]`, item.IMEI);
    });

    //console.log("--3-43-4",smartDeviceNumbers);

    try {
      Swal.fire({
        title: 'Processing...',
        text: 'please wait...',
        allowOutsideClick: false,
        didOpen: () => {
          Swal.showLoading();
        },
      });
      let response = await fetch(`${BaseURL}/user/edit/${UserEditData._id}`, {
        method: "PUT",
        body: formData,
        headers: {
          Authorization: `Bearer ${uniqueToken}`,
        },
      });

      // if (!response.ok) {
      //   throw new Error(`HTTP error! status: ${response.status}`);
      // }

      let responseData = await response.json();
      Swal.close();
      if (responseData.statusCode === 200) {

        setFormInitialized(true);

        Swal.fire({
          icon: "success",
          title: "Success!",
          text: "User updated successfully...",
          showConfirmButton: false,
          timer: 1500,
        });
        navigate(`/usermanagement/users`);
      } else {
        Swal.close();
        Swal.fire({
          icon: "error",
          title: "Error",
          text: `${responseData?.message}`,
        });
      }
    } catch (error) {
      Swal.close();
      console.error("Error in EditUser:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: error?.response?.data?.message,
      });
    }
  };

console.log("Users", Users);
console.log("country", selectedCountry);


  return (
    <div className="container-fluid">
          {loading ? (
      <div className="text-center">
        <div className="spinner-border text-primary" role="status">
          <span className="sr-only">Loading...</span>
        </div>
      </div>
    ) : (

      <div className="row">
        <div className="col-sm-12">
          <div className="card">
            <h1 className="page-title"></h1>
            <div className="portlet light bordered">
              <div className="portlet-title row">
                <div className="caption font-dark col-md-10">
   
                  <h4 className="caption-subject bold uppercase mx-3">Edit Users</h4>
                </div>
                <div className="caption font-dark col-md-2">
                  <h5 className="caption-subject bold uppercase mx-3">
                    <button className="btn btn-success" onClick={() => navigate(-1)}>Back</button>
                  </h5>
                </div>
              </div>
              <div className="portlet-body mx-3">
                <hr style={{ marginTop: ""}} />
                <div className="row">
                  <div className="col-sm-12">
                    <form className="form-horizontal" encType="multipart/form-data" role="form" method="post" style={{ marginTop: "-20px" }}>
                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="name_id" className="col-sm-2 control-label"> Name</label>
                          <div className="col-sm-6">
                            <input onChange={handleNameChange} value={Name} className="form-control" id="name_id" />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="latitude_id" className="col-sm-2 control-label">Mobile</label>
                          <div className="col-sm-6">
                            <input onChange={handleMobileChange} className="form-control" id="latitude_id" value={Mobile} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="email_id" className="col-sm-2 control-label">Email</label>
                          <div className="col-sm-6">
                            <input onChange={handleEmailChange} className="form-control" id="email_id" value={Email} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>
                      <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Enter Vehicle Number
                            </label>
                            <div className="col-sm-6">
                              <input
                              type="vehilcle_number"
                                onChange={handleVehicleNumberChange}
                                className="form-control"
                                id="vehicle_number"
                                name="Vehicle_Number"
                                value={VehicleNumber}
                              
                              />
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                      </div>

                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="longitude_id" className="col-sm-2 control-label">
                              Station Name
                            </label>
                            <div className="col-sm-6">
                              <select
                              type="station_id"
                                onChange={handleStationID}
                                className="form-control"
                                id="station_id"
                                name="station_id"
                                value={selectedStation}
                              
                              >
                                <option value="">Select Station</option>
                                {StationData?.map((item) => {
                                  return (
                                    <option
                                      key={item?._id}
                                      value={item?._id}
                                    >
                                      {item?.station_name}
                                    </option>
                                  );
                                })}
                                </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                 

                      {/* <div className="form-group">
                        <div className="row">
                          <label htmlFor="status_id" className="col-sm-2 control-label">Status</label>
                          <div className="col-sm-6">
                            <select onChange={handleStatusChange} className="form-control" value={selectedStatusType}>
                              <option value="">Select Status</option>
                              <option value="active">Active</option>
                              <option value="inactive">Inactive</option>
                              <option value="deleted">Deleted</option>
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div> */}

                    

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="country_id" className="col-sm-2 control-label">Select Country</label>
                          <div className="col-sm-6">
                            <select onChange={handleCountryChange} className="form-control" value={selectedCountry._id || ""}>
                              <option value="">Select Country</option>
                              {countries.map((country) => (
                                <option key={country._id} value={country._id} data-key={country.id}>
                                  {country.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="state_id" className="col-sm-2 control-label">Select State</label>
                          <div className="col-sm-6">
                            <select onChange={handleStateChange} className="form-control" value={selectedState.id}>
                              <option value="">Select State</option>
                              {states.map((state) => (
                                <option key={state._id} value={state.id}>
                                  {state.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="city_id" className="col-sm-2 control-label">Select City</label>
                          <div className="col-sm-6">
                            <select onChange={(e) => setSelectedCity(e.target.value)} className="form-control" value={selectedCity}>
                              <option value="">Select City</option>
                              {cities.map((city) => (
                                <option key={city._id} value={city._id}>
                                  {city.name}
                                </option>
                              ))}
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="address_id" className="col-sm-2 control-label">Address</label>
                          <div className="col-sm-6">
                            <textarea onChange={handleAddressChange} className="form-control" id="address_id" value={Address} />
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

{/* 
                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="parent_id" className="col-sm-2 control-label">Parent</label>
                          <div className="col-sm-6">
                            <select onChange={handleParentChange} className="form-control" value={selectedParent}>
                              <option value="">Select Parent</option>
                              {/* Populate with parent options 
                            </select>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div> */}
                        <div className="form-group">
                          <div className="row">
                            <label htmlFor="statusType" className="col-sm-2 control-label">
                              User Type
                            </label>
                            <div className="col-sm-6">
                              <select
                                onChange={handleUserTypeChange}
                                value={userType}
                                type="text"
                                className="form-control"
                                id="statusType"
                                name="statusType"
                              >
                                <option value="0">Select User Type</option>
                                <option value="Normal User">Normal User</option>
                                <option value="Vendor">Vendor</option>
                              </select>
                            </div>
                            <span className="col-sm-4 control-label"></span>
                          </div>
                        </div>

                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="profile_image" className="col-sm-2 control-label">Profile Image</label>
                          <div className="col-sm-6">
                            <input type="file" onChange={handleSelectFileChange} className="form-control" id="profile_image" />
                          </div>
                          <div className="col-sm-4 control-label">
                            {/* Show image preview if an existing image URL is available */}
                            {Imageurl && typeof Imageurl === 'string' && (
                              <img
                                src={Imageurl} // Use the image URL for src
                                alt="Current Category"
                                style={{ width: '100px', height: '100px', objectFit: 'cover', marginLeft: "180px" }}
                              />
                            )}

                          
                          </div>
                        </div>
                      </div>


                      <div className="form-group">
                        <div className="row">
                          <label htmlFor="smart_device_input" className="col-sm-2 control-label">
                            Smart Device Number
                          </label>
                          <div className="col-sm-6">
                            <div
                              className="form-control d-flex flex-wrap align-items-center"
                              style={{ minHeight: '38px', gap: '5px' }}
                            >
                              {smartDeviceNumbers.map((num, index) => (
                                <span
                                  key={index}
                                  className="badge bg-primary text-white d-flex align-items-center"
                                  style={{ padding: '5px 10px', borderRadius: '15px' }}
                                >
                                  {num}
                                  <button
                                    type="button"
                                    onClick={() => removeSmartDeviceNumber(index)}
                                    style={{
                                      background: 'transparent',
                                      border: 'none',
                                      color: 'white',
                                      marginLeft: '5px',
                                      cursor: 'pointer',
                                      fontWeight: 'bold'
                                    }}
                                  >
                                    ×
                                  </button>
                                </span>
                              ))}

                              <input
                                type="text"
                                id="smart_device_input"
                                name="SmartDeviceInput"
                                className="border-0 flex-grow-1"
                                placeholder="Type and press space"
                                value={smartDeviceNumber}
                                onChange={handleSmartDeviceNumber}
                                style={{ outline: 'none' }}
                              />
                            </div>
                          </div>
                          <span className="col-sm-4 control-label"></span>
                        </div>
                      </div>

                      <div className="form-group">
                        <div className="row">
                          <div className="col-sm-12 text-center">
                            <button type="button" onClick={() => EditUser(UserEditData)} className="btn btn-primary">Update</button>
                          </div>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
        )}
    </div>
  );
}

export default Edit;
